import _ from 'lodash';
import { SearchKeyInputItems } from '../component/form/search-key-input.component';
import i18n from '../i18n';
import { Reseller } from '../models';
import { accountState } from '../page/my-account/account-state';
import apiManage from '../request';
import { Option } from '../component/form/select-input-multiple';

/**
 * 如果是admin，则筛选框加上经销商筛选
 * @param selectFilterLists 
 * @returns 
 */
export const getResellerFilter = (selectFilterLists: SearchKeyInputItems[], isNotNeedAdminOptions?: boolean) => {
    const result = [...selectFilterLists]
    const resellerFilter: SearchKeyInputItems = {
        value: 'belonged_reseller',
        label: i18n.t('reseller_page_text_reseller'),
        type: 'AUTO_COMPLETE_SELECT',
        fetchData: (value) => getResellerList(!!isNotNeedAdminOptions, value),
    };
    if (accountState.accountType === 'ADMIN') {
        result.push(resellerFilter);
    }
    return result;
}

/**
 * 获取经销商列表
 * @param searchValue
 * @returns
 */
export const getResellerList = async (isNotNeedAdminOptions: boolean, searchValue?: string): Promise<Option[]> => {
    const res = await apiManage.get_reseller_condition({
        pagination_per_page: 10000,
        pagination_page: 1,
        nickname: searchValue || undefined
    });
    if (res && !res.error) {
        const resellerList: Reseller[] = _.get(res, '[0].dbResults') || [];
        let options: Option[] = resellerList.map((reseller) => ({
            value: reseller._id || '',
            label: `${reseller.first_name} ${reseller.last_name}`,
        }))
        if (!isNotNeedAdminOptions) {
            options = [{ label: 'SW总部直营', value: 'Admin' }].concat(options);
        }
        return options
    }
    return []
}



/**
 * 如果是admin，则筛选框加上经销商筛选
 * @param filterList 
 * @returns 
 */
export const addResellerFilter = (filterList: Array<{
    value: string;
    label: string;
}>) => {
    const result = [...filterList]
    const resellerFilter = {
        value: 'reseller',
        label: i18n.t('reseller_page_text_reseller')
    };
    if (accountState.accountType === 'ADMIN') {
        result.push(resellerFilter);
    }
    return result;
}

/**
 * -不同类型显示不同文字
 * Staff_Login 员工登录
 * Admin_Login 管理员登录
 * Reseller_Login 经销商登录
 */
export const getOperationTypeText = (type: string) => {
    switch (type) {
        case 'Staff_Login':
            return 'Staff';
        case 'Admin_Login':
            return 'Admin';
        case 'Reseller_Login':
            return 'Reseller';
        default:
            return '';
    }
}